import React from 'react';
import { useTranslation } from 'app/shared/i18n';

export const Contact = () => {
  const { t } = useTranslation();
  return (
    <section id="contact" style={{ padding: '0 24px 40px' }}>
      <div style={{ maxWidth: 1280, margin: '0 auto' }}>
        <div className="ms-card" style={{ padding: '16px 20px', textAlign: 'center' }}>
          <span style={{ fontSize: 14, color: 'var(--muted)' }}>{t('contact.issue')} </span>
          <a href="https://t.me/q8tools" target="_blank" rel="noreferrer" style={{ fontWeight: 600 }}>
            Telegram
          </a>
          <span style={{ color: 'var(--dim)' }}> • </span>
          <a href="https://t.me/+Gc0cQ_427BQ4NWQ1" target="_blank" rel="noreferrer" style={{ fontWeight: 600 }}>
            Group Chat
          </a>
        </div>
      </div>
    </section>
  );
};
